// extracted by mini-css-extract-plugin
module.exports = {"medium":"styles_medium__LC2dR","small":"styles_small__OYd6_","xsmall":"styles_xsmall__Om1t6"};